import { on } from 'delegated-events'
import scrollTo from '../common/scrollTo'
import debounce from 'lodash/debounce'
import { pristineConfig } from '../components/forms'
import Pristine from 'pristinejs'

const SELECTORS = Selectors({
  accountForm: 'booking-account-form',
  defaultPaymentForm: 'booking-default-payment-form',
  stripeCardElement: 'card-element',
  passwordField: '[type=password][name=Password]',
  confirmPasswordField: '[type=password][name=ConfirmPassword]'
})

const $accountForm = document.querySelector(SELECTORS.asClass('accountForm'))
const $defaultPaymentForm = document.querySelector(SELECTORS.asClass('defaultPaymentForm'))
const $passwordField = document.querySelector(SELECTORS.passwordField)
const $confirmPasswordField = document.querySelector(SELECTORS.confirmPasswordField)
const $defaultPaymentFormSubmitButton = document.querySelector(`${SELECTORS.asClass('defaultPaymentForm')} [type=submit]`)

const state = {
  stripe: null,
  stripeCard: null
}

const fn = {
  init: () => {
    if ($accountForm) {
      fn.setupValidation()
    }

    if ($defaultPaymentForm) {
      state.stripe = window.Stripe($defaultPaymentForm.dataset.stripePubKey)
      $defaultPaymentForm.addEventListener('submit', fn.handlePaymentFormSubmit)
      fn.setupStripeCard()
    }
  },

  setupValidation: () => {
    const pristine = new Pristine($accountForm, pristineConfig)

    if ($confirmPasswordField) {
      pristine.addValidator($confirmPasswordField, function (value) {
        return value === $passwordField.value
      }, "Passwords don't match", 10, false)
    }

    // Hide any native SilverStripe errors
    on('keyup',
      `${SELECTORS.asClass('form')} input`,
      e => {
        const $field = e.target.closest('.field')
        const $error = $field.querySelector('.message')

        if ($error) {
          $error.remove()
        }
      }
    )

    $accountForm.addEventListener('submit', (e) => {
      const valid = pristine.validate()

      if (!valid) {
        e.preventDefault()
        const $firstError = $accountForm.querySelector('.field.has-error')

        if ($firstError) {
          scrollTo($firstError, 150, () => $firstError.querySelector('input') && $firstError.querySelector('input').focus())
        }

        return false
      }
    })
  },

  setupStripeCard: () => {
    const style = {
      base: {
        fontSize: '16px',
        fontFamily: 'Open Sans, sans-serif',
        color: '#2c2c2c',
        fontSmoothing: 'antialiased',
        textTransform: 'uppercase',
        '::placeholder': {
          color: '#b4b4b4'
        }
      },
      invalid: {
        color: '#b9112a'
      }
    }

    const card = state.stripe.elements().create('card', { style })
    card.mount(SELECTORS.asId('stripeCardElement'))
    state.stripeCard = card

    card.addEventListener('change', ({error}) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ''
      }
    })

    window.addEventListener('resize', debounce(fn.updateStripeCard, 250))
    fn.updateStripeCard()
  },

  updateStripeCard: () => {
    let fontSize = '16px'

    if (window.matchMedia('(min-width: 1200px)').matches) {
      fontSize = '18px'
    }

    const style = {
      base: {
        fontSize
      }
    }

    state.stripeCard.update({ style })
  },

  handlePaymentFormSubmit: (e) => {
    if (e.target.forceSubmit) {
      return true
    }

    e.preventDefault()

    // Handle Stripe
    $defaultPaymentFormSubmitButton.disabled = true

    state.stripe.createToken(state.stripeCard).then((result) => {
      if (result.error) {
        const errorElement = document.getElementById('card-errors')
        errorElement.textContent = result.error.message
        $defaultPaymentFormSubmitButton.disabled = false
      } else {
        fn.stripeTokenHandler(result.token)
      }
    })

    return false
  },

  stripeTokenHandler: (token) => {
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeToken')
    hiddenInput.setAttribute('value', token.id)
    $defaultPaymentForm.appendChild(hiddenInput)

    $defaultPaymentForm.forceSubmit = true
    $defaultPaymentFormSubmitButton.disabled = false
    $defaultPaymentFormSubmitButton.click()
    $defaultPaymentFormSubmitButton.disabled = true
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-bookingaccountpage'),
  run: fn.init
}
